import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: require("./locales/en.json"),
    },
    fr: {
      translation: require("./locales/fr.json"),
    },
    it: {
      translation: require("./locales/it.json"),
    },
    es: {
      translation: require("./locales/es.json"),
    },
  },
  lng: "fr",
  fallbackLng: "fr",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
